import { ReducerMessageInterface } from "../interfaces/messagesInterface";

export const MESSAGE = {
    NEW: "MESSAGE/NEW",
    CLEAR: "MESSAGE/CLEAR"
}

const initialState = {
    messageAcc: JSON.parse(localStorage.getItem("messages") || "[]")
};

export default function (state = initialState, action: ReducerMessageInterface) {
    switch (action.type) {
        case MESSAGE.NEW: {
            localStorage.setItem("messages", JSON.stringify([ ...state.messageAcc, action.payload ]))
            
            return {
                ...state,
                messageAcc: [
                    ...state.messageAcc,
                    action.payload
                ]
            }
        }
        
        case MESSAGE.CLEAR: {
            return {
                messageAcc: []
            }
        }
        
        default: 
            return{
                ...state
            }
    }
}